import { Accordion } from "@mantine/core";
import { useColors } from "../../../hooks/colors/useColors";
import { useTranslation } from "next-i18next";
import { Text } from "@mantine/core";

export function FAQ() {
  const { colors } = useColors();
  const itemStyle = { item: { backgroundColor: colors.secondary } };
  const { t } = useTranslation("common");

  function renderItem(index: number) {

    return (
      <Accordion.Item
        value={index.toString()}
        color={colors.secondaryContrast}
        styles={itemStyle}
      >
        <Accordion.Control>
          <Text color={colors.dark}>{t(`faq-page.${index}-title`)}</Text>
        </Accordion.Control>
        <Accordion.Panel>
          <div
            dangerouslySetInnerHTML={{
              // @ts-ignore
              __html: t(`faq-page.${index}-content`),
            }}
          />
        </Accordion.Panel>
      </Accordion.Item>
    );
  }

  return (
    <Accordion
      radius="xl"
      variant="separated"
      color={colors.secondary}
      styles={{
        control: {
          backgroundColor: colors.secondary,
          borderRadius: 6,
          color: colors.white,
        },
        label: {
          // fontWeight: 600,
          fontSize: 20,
        },
      }}
    >
      {renderItem(1)}
      {renderItem(2)}
      {renderItem(3)}
      {renderItem(4)}
      {renderItem(5)}
      {renderItem(6)}
      {renderItem(7)}
      {renderItem(8)}
      {renderItem(9)}
      {renderItem(10)}
      {renderItem(11)}
      {renderItem(12)}
      {renderItem(13)}
      {renderItem(14)}
      {renderItem(15)}
      {renderItem(16)}
      {renderItem(17)}
      {renderItem(18)}
    </Accordion>
  );
}
